import { ActionType } from '../../core/redux/actionType';
import { ApiReducer, makeApiAction, makeApiReducer, makeRsaaTypes } from '../../core/api/rsaa';
import { addError, addLoading, noLoadingNoError, getLoading } from '../../core/api/module';
import * as R from 'ramda';
import { Endpoints } from '../../core/api/endpoints';
import { UserInfo } from '../authState';


const KEY_ACTION = ActionType.SamlAssertionRequest;
const ACTIONS = [
  ActionType.SamlAssertionRequest,
  ActionType.SamlAssertionResponse,
  ActionType.SamlAssertionError,
];


type Payload = UserInfo;


type Meta = {
  email: string;
};


/**
 * Dispatch this action to authenticate to the portal through Saml SSO 
 */
export const samlAssertionAction = (email?: string) => makeApiAction<Payload, Meta>({
  method: 'POST',
  endpoint: Endpoints.SamlAssertion,
  headers: { 'content-type': 'application/json' },
  body: JSON.stringify({ email: email }),
  types: makeRsaaTypes<Payload, Meta>(ACTIONS),
  bailout: state => !!getLoading(state, KEY_ACTION),
});

const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg);
  }

  const successState = noLoadingNoError(state, KEY_ACTION);

  return R.assocPath(['auth', 'currentUser'], payload, successState);
};

export const samlAssertionReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);